export default __webpack_public_path__ + "static/media/waiting_rescue.7fa51ea2.png";